import { render, staticRenderFns } from "./link.vue?vue&type=template&id=16515fd2"
import script from "./link.vue?vue&type=script&lang=ts"
export * from "./link.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports